import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'
import LogoIcon from 'icons/logo-mini.svg'
import InstaIcon from 'icons/insta.svg'

import EhoIcon from 'icons/eho.svg'
import CookfoxIcon from 'icons/cookfox.svg'
import MAGIcon from 'icons/mag.svg'
import DEIcon from 'icons/de.svg'

export const Wrapper = styled.footer`
  padding: ${calculateResponsiveSize(12)} ${calculateResponsiveSize(26)}
    ${calculateResponsiveSize(26)} ${calculateResponsiveSize(52)};
  display: flex;
  justify-content: space-between;
  border-top: 1px solid var(--brick);
  font-family: 'MrEavesXLModOT';
  font-weight: 400;
  font-size: ${calculateResponsiveSize(14)};
  line-height: 130%;
  letter-spacing: 0em;

  &.hide {
    display: none;
  }

  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(12)}
      ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(50)}
      ${calculateMobileResponsiveSize(20)};
    font-size: ${calculateMobileResponsiveSize(13)};
    line-height: ${calculateMobileResponsiveSize(13)};
    flex-direction: column;
  }
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${calculateResponsiveSize(37)};
  ${mediaMax('mobile')} {
    gap: 0;
    & div {
      display: flex;
      justify-content: space-between;
      & .fact {
        width: 48.5%;
      }
    }
  }
`
export const Right = styled.div`
  display: flex;
  ${mediaMax('mobile')} {
    flex-wrap: wrap;
  }
`
export const Col = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: ${calculateResponsiveSize(37)};
  a {
    display: flex;
  }
  &.last {
    margin-left: -${calculateResponsiveSize(19)};
    align-items: flex-end;
    justify-content: space-between;
  }
  &.zero {
    margin-right: ${calculateResponsiveSize(80)};
  }
  &.first {
    margin-right: ${calculateResponsiveSize(35)};
    gap: 2.8625vw;
  }
  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(144)};
    gap: ${calculateMobileResponsiveSize(8)};

    &.first {
      margin-right: ${calculateMobileResponsiveSize(38)};
      gap: 5.603435vw;
    }
    &.last {
      margin-left: ${calculateMobileResponsiveSize(0)};
      width: auto;
      margin-top: ${calculateMobileResponsiveSize(20)};
    }
  }
`
export const Icons = styled.div`
  display: flex;
  gap: ${calculateResponsiveSize(32)};
  align-items: flex-end;
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(13)};
  }
`

export const Logo = styled((props) => <Link {...props} />)`
  width: ${calculateResponsiveSize(117)};
  height: ${calculateResponsiveSize(25)};
  -webkit-mask: url(${LogoIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;
  flex: 0 0 auto;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(162)};
    height: ${calculateMobileResponsiveSize(34)};
    margin-bottom: ${calculateMobileResponsiveSize(20)};
  }
`
export const Insta = styled.a`
  width: ${calculateResponsiveSize(22)};
  height: ${calculateResponsiveSize(22)};
  -webkit-mask: url(${InstaIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;
  flex: 0 0 auto;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(13)};
    height: ${calculateMobileResponsiveSize(13)};
    margin-bottom: ${calculateMobileResponsiveSize(20)};
  }
`
export const Eho = styled.div`
  width: ${calculateResponsiveSize(28)};
  height: ${calculateResponsiveSize(27)};
  -webkit-mask: url(${EhoIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(12)};
    height: ${calculateMobileResponsiveSize(11)};
    position: absolute;
    right: ${calculateMobileResponsiveSize(38)};
    bottom: ${calculateMobileResponsiveSize(52)};
  }
`
export const CookFox = styled.div`
  width: ${calculateResponsiveSize(41)};
  height: ${calculateResponsiveSize(40)};
  -webkit-mask: url(${CookfoxIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(21)};
    height: ${calculateMobileResponsiveSize(20)};
  }
`
export const Mag = styled.div`
  width: ${calculateResponsiveSize(95)};
  height: ${calculateResponsiveSize(32)};
  -webkit-mask: url(${MAGIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(48)};
    height: ${calculateMobileResponsiveSize(16)};
  }
`
export const De = styled.div`
  width: ${calculateResponsiveSize(116.6)};
  height: ${calculateResponsiveSize(25)};
  -webkit-mask: url(${DEIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--brick);
  display: flex;

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(63)};
    height: ${calculateMobileResponsiveSize(13.7)};
  }
`
